import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.validate()
  }

  validate() {
    this.submitTarget.disabled = this.inputTarget.value.length !== 10
  }
}
